import { DefaultLayout } from "@westpierstudio/luma/layout";
import { View } from "@westpierstudio/luma/mvc";
import { GameServices } from "game/GameServices";
import { Sprite, Point } from "pixi.js";

export class KSGLogo extends View {

    protected logo: Sprite;
    layout: DefaultLayout;

    /**
     *
     * @param services
     * @param layout Is the layout service this instance of the component is rendering in.
     */
    constructor(protected override readonly services: GameServices, layout: DefaultLayout) {
        super(services);
        const { resources, factory } = services;

        this.layout = layout;


        const defaultSpec = resources.getSpec(`ksg-logo`).ksgLogo;
        this.logo = factory.createSprite(defaultSpec, this);
    }

    resize(safeArea = { top: 0, bottom: 0 }) {

        if (this.parent && this.parent.parent) {
            this.parent.parent.updateTransform();
        }

        const { factory } = this.services;

        this.logo.scale.set(1);

        const defaultBucket = this.services.loadscreenLayout.calculateLayout();
        const actualBucket = this.layout.calculateLayout();

        let scale = 1;
        scale /= actualBucket.stageScale; // undo current bucket scale
        scale *= defaultBucket.stageScale; // apply default (unpadded) bucket scale

        if (this.layout.landscape) {
            scale *= 1; // always scale of 1 in landscape
            factory.applySpec(this.logo, { x: 4, y: 170, scale });
        } else {
            const bounds = this.layout.getScreenBoundaryInBucketSpace();

            const aspectRatio = bounds.width / bounds.height;

            const defaultPortraitLayout = { gameScale: 1.525, scale: 0.9, top: 5, left: 5 };
            const ipadMiniPortraitLayout = { scale: 0.5, minAspectRatio: 0.75 };

            let layout = { ...defaultPortraitLayout };

            if (aspectRatio >= ipadMiniPortraitLayout.minAspectRatio) {
                layout = { ...layout, ...ipadMiniPortraitLayout };
            }

            scale *= layout.gameScale;
            scale *= layout.scale;

            this.logo.scale.set(scale);

            const positionScreenSpace = new Point(layout.left, safeArea.top + layout.top);
            const positionLocalSpace = this.toLocal(positionScreenSpace);
            factory.applySpec(this.logo, { x: positionLocalSpace.x, y: positionLocalSpace.y });
        }
    }
}